// extracted by mini-css-extract-plugin
export default {"App":"App_App__ezJTz","wrapper":"App_wrapper__ms9Kr"};